import Radio from '~components/dumbs/Radio'
import Column from '~components/dumbs/Column'
import * as Styled from './styled'
import { Props } from './interfaces'
import chunk from 'lodash/chunk'
import sortBy from 'lodash/sortBy'

function RadioList({ list, name, title, isValid, register, isOrderedList = true }: Props) {
  const numberOfChunks = 5
  const chunks = chunk(list, numberOfChunks)
  const orderedList = chunks?.map?.((list) => {
    return sortBy(list, ['name'])
  })
  const renderedList = isOrderedList ? orderedList : chunks

  return (
    <Styled.CenteredWrapper $isValid={isValid}>
      <Column>
        {title && <Styled.ColumnTitle>{title}</Styled.ColumnTitle>}
        <Styled.Row>
          {renderedList?.map?.((radioList, index) => (
            <Styled.Content key={index}>
              {radioList?.map?.((radio) => (
                <Radio
                  key={radio.id}
                  register={register}
                  value={radio.id}
                  name={name}
                  label={radio.name}
                />
              ))}
            </Styled.Content>
          ))}
        </Styled.Row>
      </Column>
    </Styled.CenteredWrapper>
  )
}

export default RadioList
